import { gaEvent } from 'src/utils'

/**
 * [TARGET]: No clique na opção de selecionar parcela
 *
 * [CONTEXTO]: Na geração de cobrança, precisamos identificar se o usuário clicou na opção de selecionar parcela.
 *
 * [REGRAS]: n/a
 *
 */
export const selectInstallmentsEvent = (installment: number) => {
  const event = {
    event: 'event',
    'event-category': `pagamentos-sellout:cartao-de-credito`,
    'event-action': 'select:parcelas',
    'event-label': `${installment}`,
  }

  gaEvent(event)
}
